import { Component, createRef } from 'react';

import type { SourceType } from '@trello/analytics-types';
import { Analytics } from '@trello/atlassian-analytics';
import { intl } from '@trello/i18n';
import { Button } from '@trello/nachos/button';

import styles from './LinkCopy.less';

interface LinkCopyProps {
  url: string;
  analyticsSource: SourceType;
  boardId?: string;
  teamId?: string;
  isTemplate?: boolean;
}

export class LinkCopy extends Component<LinkCopyProps, { buttonText: string }> {
  linkInput = createRef<HTMLInputElement>();
  // @ts-expect-error
  timer: number;
  // @ts-expect-error
  // eslint-disable-next-line @eslint-react/no-unused-class-component-members
  isTemplate: boolean;

  state = {
    buttonText: intl.formatMessage({
      id: 'link copy.copy',
      defaultMessage: 'Copy',
      description: 'Button text for copying a link',
    }),
  };

  componentDidMount() {
    const linkInput = this.linkInput.current;
    if (linkInput) {
      // eslint-disable-next-line @eslint-react/web-api/no-leaked-timeout
      setTimeout(() => {
        linkInput.select();
      }, 10);
    }
  }

  componentWillUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  handleButtonClick = () => {
    if (this.linkInput.current) {
      this.linkInput.current.select();
      document.execCommand('copy');
      this.setState({
        buttonText: intl.formatMessage({
          id: 'link copy.copied',
          defaultMessage: 'Copied!',
          description: 'Button text for copied link',
        }),
      });
    }

    // Create a timeout to change "Copied!" back to "Copy" as a visual indicator
    // that the link has successfully completed being copied to the clipboard
    this.timer = window.setTimeout(() => {
      this.setState({
        buttonText: intl.formatMessage({
          id: 'link copy.copy',
          defaultMessage: 'Copy',
          description: 'Button text for copying a link',
        }),
      });
    }, 2000);

    Analytics.sendClickedButtonEvent({
      buttonName: 'linkCopyButton',
      source: this.props.analyticsSource,
      containers: {
        board: { id: this.props.boardId },
        organization: { id: this.props.teamId },
      },
      attributes: { isTemplate: this.props.isTemplate },
    });
  };

  handleInputClick = () => {
    if (this.linkInput.current) {
      this.linkInput.current.select();
    }

    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'input',
      actionSubjectId: 'linkCopyInput',
      source: this.props.analyticsSource,
      containers: {
        board: { id: this.props.boardId },
        organization: { id: this.props.teamId },
      },
      attributes: { isTemplate: this.props.isTemplate },
    });
  };

  render() {
    return (
      <div className={styles.shareLinkContainer}>
        <input
          readOnly
          value={this.props.url}
          onClick={this.handleInputClick}
          ref={this.linkInput}
        />
        <Button
          appearance="primary"
          title={this.state.buttonText}
          onClick={this.handleButtonClick}
        >
          {this.state.buttonText}
        </Button>
      </div>
    );
  }
}
